var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDislyk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8251 4.03125L8.88758 2.53125C8.63758 2.28125 8.07508 2.15625 7.70008 2.15625H5.32508C4.57508 2.15625 3.76258 2.71875 3.57508 3.46875L2.07508 8.03125C1.76258 8.90625 2.32508 9.65625 3.26258 9.65625H5.76258C6.13758 9.65625 6.45008 9.96875 6.38758 10.4063L6.07508 12.4062C5.95008 12.9687 6.32508 13.5938 6.88758 13.7813C7.38758 13.9688 8.01258 13.7187 8.26258 13.3437L10.8251 9.53125",
    stroke: "#F7A91C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0117 4.03125V10.1562C14.0117 11.0312 13.6367 11.3438 12.7617 11.3438H12.1367C11.2617 11.3438 10.8867 11.0312 10.8867 10.1562V4.03125C10.8867 3.15625 11.2617 2.84375 12.1367 2.84375H12.7617C13.6367 2.84375 14.0117 3.15625 14.0117 4.03125Z",
    stroke: "#F7A91C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislyk);
export default __webpack_public_path__ + "static/media/dislyk.d2881177b1dc9c6aca17cc6e1548a150.svg";
export { ForwardRef as ReactComponent };